export default __webpack_public_path__ + "upload/yt.4e86587e.svg";